import React, { useState } from 'react';
import{useLocation} from 'react-router-dom'
const SingleProjectDetails = () => {
    const location = useLocation();

    const [project, setProject] = useState(location.state.data)
    return (
        <div>
            <h2 className='text-center text-4xl font-bold mt-5'>Project Details{project?.name}</h2>
            <div className='grid grid-cols-3 gap-8 mt-12'>
                <img src={project?.img1} alt=""/>
                <img src={project?.img2} alt=""/>
                <img src={project?.img3} alt=""/>
            </div>
        </div>
    );
};

export default SingleProjectDetails;